// extracted by mini-css-extract-plugin
export default {"components":"Components_components__w7LZK","heading":"Components_heading__j2mTB","container":"Components_container__wviU7"};